import { FunctionComponent } from 'react';
import { useSelector } from '@cbridge-utils/react-redux';
import { NavigationBlockItem } from '@cbridge-tools/navigation-block';
import { isMatchedPathnameSelector } from '@cbridge-packages/routing';
import { ILpNavigationItemProps } from './LpNavigationItem.interface';

export const LpNavigationItem: FunctionComponent<ILpNavigationItemProps> = ({ item }) => {
  const { label, href } = item;

  const isSelected = useSelector(isMatchedPathnameSelector, { pattern: href });

  return (
    <NavigationBlockItem
      label={label}
      href={href}
      isSelected={isSelected}
    />
  );
};
